import api from "../../config/api";
import { firebase } from "../../config/firebase";
export const FETCH_MERCHANDISE = "FETCH_MERCHANDISE";
export const FETCH_MERCHANDISE_SUCCESS = "FETCH_MERCHANDISE_SUCCESS";
export const FETCH_MERCHANDISE_FAILURE = "FETCH_MERCHANDISE_FAILURE";

export const fetchMerchandise = (id) => ({
  type: FETCH_MERCHANDISE,
  id,
});

export const fetchMerchandiseSuccess = (data) => ({
  type: FETCH_MERCHANDISE_SUCCESS,
  data,
});

export const fetchMerchandiseFailure = () => ({
  type: FETCH_MERCHANDISE_FAILURE,
});

export const getMerchandiseDetail = (id) => {
  return (dispatch) => {
    dispatch(fetchMerchandise());
    return firebase.reloadAuth().then((res) => {
      try {
        const token = res.ya === null ? res.za : res.ya;

        api
          .get("/merchandise/", { id: id }, token)
          .then((res) => {
            dispatch(fetchMerchandiseSuccess(res));
            return res;
          })
          .catch((err) => dispatch(fetchMerchandiseFailure(err)));
      } catch (err) {
        console.log(err);
      }
    });
  };
};
